// src/auth/getToken.ts
import {
  IPublicClientApplication,
  AuthenticationResult,
  InteractionRequiredAuthError,
  SilentRequest,
} from "@azure/msal-browser";

export async function getAccessToken(
  instance: IPublicClientApplication,
  scopes: string[]
): Promise<string | null> {
  const account = instance.getActiveAccount();
  if (!account) {
    console.warn("[MSAL] No active account – issuing loginRedirect");
    await instance.loginRedirect({ scopes });        
    return null;
  }
  const silentRequest: SilentRequest = { scopes, account };

  try {
    const result: AuthenticationResult =
      await instance.acquireTokenSilent(silentRequest);
    return result.accessToken;
  } catch (err: unknown) {
    if (err instanceof InteractionRequiredAuthError) {
      console.warn("[MSAL] Silent token failed – issuing acquireTokenRedirect");

      await instance.acquireTokenRedirect({ scopes });
      return null;
    }
    console.error("[MSAL] Token acquisition failed:", err);
    return null;
  }
}
